import { render } from "./Or_tableDouble.vue?vue&type=template&id=4547f7b1&scoped=true&ts=true"
import script from "./Or_tableDouble.vue?vue&type=script&lang=ts"
export * from "./Or_tableDouble.vue?vue&type=script&lang=ts"

import "./Or_tableDouble.vue?vue&type=style&index=0&id=4547f7b1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4547f7b1"]])

export default __exports__